import { Box, Dialog, DialogTitle, Grid, IconButton } from "@mui/material";
import { LIGHT_GREY } from "styles/oneOffColor";

import VideoEmbed from "components/VideoEmbed";

interface Props {
  link: string;
  open: boolean;
  handleClose: () => void;
  title: string;
  videoPreview?: string;
  widthPercentage?: number;
}
const VideoDialog = ({
  link,
  open,
  handleClose,
  title,
  videoPreview,
  widthPercentage = 100,
}: Props) => {
  return (
    <Dialog
      open={open}
      onClose={handleClose}
      sx={{
        "& .MuiDialog-container": {
          "& .MuiPaper-root": {
            width: "100%",
            maxWidth: 750,
          },
        },
      }}
    >
      <DialogTitle sx={{ backgroundColor: LIGHT_GREY }}>
        <Grid container justifyContent="space-between" alignItems="center">
          {title}

          <IconButton onClick={handleClose}>
            <Box
              sx={{ fontSize: 18 }}
              component="i"
              className="fa-regular fa-xmark"
            />
          </IconButton>
        </Grid>
      </DialogTitle>

      <VideoEmbed
        linkPreview={videoPreview}
        link={link}
        widthPercentage={widthPercentage}
      />
    </Dialog>
  );
};

export default VideoDialog;
